import type { ExtRoute } from '@slims-pro/ext-api';
import { extraRoutes } from '@slims-pro/ext-web';

const PATH = /^[a-z][a-z0-9-]*$/;
// Same grammar as @slims-pro/client-config's EXT_FEATURE_KEY (not imported: it pulls in node:fs).
const EXT_KEY = /^x\.[a-z][a-z0-9-]*$/;

/** The extension's routes, validated (ADR-013 §4): a bad path, a non-`x.` key or a duplicate path throws. */
export function validateExtRoutes(routes: readonly ExtRoute[]): readonly ExtRoute[] {
	const seen = new Set<string>();
	for (const r of routes) {
		if (!PATH.test(r.path)) throw new Error(`extension route path "${r.path}" must match ${PATH}`);
		if (!EXT_KEY.test(r.feature))
			throw new Error(`extension route /x/${r.path}: feature "${r.feature}" must match ${EXT_KEY}`);
		if (seen.has(r.path)) throw new Error(`extension route /x/${r.path} is defined twice`);
		seen.add(r.path);
	}
	return routes;
}

/** `@slims-pro/ext-web`'s `extraRoutes`, checked at module load; mounted at `/x/<path>`. */
export const EXT_ROUTES = validateExtRoutes(extraRoutes);
